import Vue from 'vue';
import ElementUI from 'element-ui';
import VueRouter from 'vue-router';
import router from './routes';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import locale from 'element-ui/lib/locale/lang/en';
import VueClipboard from 'vue-clipboard2';
import InfiniteLoading from 'vue-infinite-loading';

import { JustDigits } from 'components/filter';

JustDigits();

Vue.use(VueRouter);
Vue.use(ElementUI, { locale });
Vue.use(VueClipboard);
Vue.use(require('vue-moment'));

import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'element-ui/lib/theme-chalk/index.css';

import { EventBus } from './event-bus.js';

console.log(EventBus);

// Routing logic
// var router = new VueRouter({
//     routes: routes,
//     mode: 'history',
//     linkActiveClass: 'open active',
//     scrollBehavior: function (to, from, savedPosition) {
//         return savedPosition || { x: 0, y: 0 };
//     },
// });

Vue.router = router;

Vue.use(VueAxios, axios);

Vue.use(InfiniteLoading, {
    /* options */
});

Vue.axios.defaults.baseURL = BASE_URL;
Vue.config.productionTip = false;

// Axios interceptor
axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('default_auth_token');
        if (token) {
            config.headers['Authorization'] = `JWT ${token}`;
        }
        return config;
    },
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            store.dispatch('logout').then(() => {
                router.push({ name: 'Login' });
            });
        }
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            store.dispatch('logout').then(() => {
                router.push({ name: 'Login', params:{unAuthorized: true}});
            });
        }
        return Promise.reject(error);
    }
);

new Vue({
    el: '#app',
    router: router,
    store: store,
    render: (h) => h(App),
});

require('bootstrap');
require('admin-lte');
require('../node_modules/admin-lte/dist/js/demo.js');
require('../node_modules/admin-lte/plugins/slimScroll/jquery.slimscroll.js');

import 'vue-swatches/dist/vue-swatches.min.css';



// WEBPACK FOOTER //
// ./src/main.js